export default "__VITE_ASSET__DTthAeVf__"